<div class="container" [style]="'height: ' + fixedHeight + 'px'">
  <div class="row">
    <div class="col-md-5">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <job-seniority-search
              [fixedHeight]="fixedHeight / 2"
              [(ngModel)]="jobSenioritySelectedValues"
              (ngModelChange)="onDeptOrSeniorityChanged()"
              [dataChanged]="dataChanged.bind(this, true)"
              (dataLoadComplete)="dataLoadComplete('seniority')"></job-seniority-search>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <job-department-search
              [fixedHeight]="fixedHeight / 2"
              [(ngModel)]="jobDepartmentSelectedValues"
              (ngModelChange)="onDeptOrSeniorityChanged()"
              [dataChanged]="dataChanged.bind(this, true)"
              (dataLoadComplete)="dataLoadComplete('department')"></job-department-search>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-7">
      <title-search
        [fixedHeight]="fixedHeight"
        [(ngModel)]="titleSelectedValues"
        (ngModelChange)="onTitlesChanged()"
        [requestNewSearch]="search.bind(this)"
        [requestNextBatch]="search.bind(this)"
        (dataLoadComplete)="dataLoadComplete('title')"
        [showSelected]="true"></title-search>
    </div>
  </div>
</div>
